Object.defineProperty(exports, "__esModule", { value: true });
var cordova_1 = require("./cordova");
Object.defineProperty(exports, "Cordova", { enumerable: true, get: function () { return cordova_1.Cordova; } });
